<template>
  <div class="admin-settings page">
    Coming Soon!
  </div>
</template>

<script>
export default {
  name: 'AdminSettings'
}
</script>
